var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-main',{attrs:{"subtitle":_vm.subtextBodyHeader}},[(_vm.thirdText)?[_c('span',{staticStyle:{"font-family":"'Arial'","color":"#00599B","font-size":"12px"}},[_vm._v(_vm._s(_vm.thirdText))])]:_vm._e()],2),_c(_vm.componentName,{tag:"component",attrs:{"text-body-header":_vm.textBodyHeader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }